import { render, staticRenderFns } from "./CertificatesList.vue?vue&type=template&id=a6e3a70e&scoped=true"
import script from "./CertificatesList.vue?vue&type=script&lang=js"
export * from "./CertificatesList.vue?vue&type=script&lang=js"
import style0 from "./CertificatesList.vue?vue&type=style&index=0&id=a6e3a70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3a70e",
  null
  
)

export default component.exports